const $ = jQuery.noConflict();

class ShowHide {
    constructor(btn, hiddenText, btnHide) {
        this.btn = btn;
        this.hiddenText = hiddenText;
        this.btnHide = btnHide;
    }
    init() {
        $(this.btn).on('click', (e) => {
            if($(this.btn).hasClass('text-visible')) {
                $(this.hiddenText).slideUp();
                $(this.btn).removeClass('text-visible');
            }
            else {
                $(this.hiddenText).slideDown();
                $(this.btn).addClass('text-visible');
            }
            
            const text = $(e.currentTarget).find('span');
            text.each((index, element) => {
                if($(element).hasClass('btn-hide')) {
                    $(element).removeClass('btn-hide')
                }
                else {
                    $(element).addClass('btn-hide');
                }
            });
        });
        
    }
}

const showHideContent = new ShowHide('.toggle-text', '.hidden-wrapper', '.btn-hide');

export default showHideContent;